const loginAndSignUp = {
  loginTips: "Hai già un account HitPaw? <1>Accedi</1>",
  loginSuccessTips: "Accesso riuscito",
  loginErrorTips: "Accesso fallito",
  loginAccountOrPasswordErrorTips: "Il tuo indirizzo e-mail o la password non erano corretti. Per favore riprova.",
  loginAccountNotExitErrorTips: "L'e-mail non è stata registrata",
  signUpTips: "Non sei ancora registrato?",
  rememberMe: "Ricordati di me",
  forgotPassword: "Ha dimenticato la password?",
  forgotPasswordTitle: "Ha dimenticato la password",
  verifyEmailBtn: "Verifica E-mail",
  resetPasswordTitle: "Resetta la password",
  resetPasswordLabel: "Si prega di reimpostare la password",
  resetPasswordPlaceholder: "Inserisci una nuova password",
  resetPasswordSuccessTips: "Reimpostazione della password riuscita",
  signUpPrivacyTips: "Registrandoti, accetti i nostri <1>Servizi d'uso</1> e <3>Politica sulla privacy </3>",
  loginPrivacyTips: "Effettuando il login, accetti il nostro <1>uso dei servizi</1> e la <3>politica sulla privacy</3>",
  signUpSuccessTips: "Il tuo account è stato registrato con successo！",
  getCode: "Ottenere codice",
  getCodeSuccessTips: "È stato inviato alla tua casella di posta, controllalo",
  verificationSuccessTips: "La verifica dell'indirizzo e-mail è riuscita",
  surveyTitle: "Benvenuto in HitPaw Online",
  surveyStep1: "<1>Passaggio 1</1>/3",
  surveyStep2: "<1>Passaggio 2</1>/3",
  surveyStep3: "<1>Passaggio 3</1>/3",
  surveyQuestion: "Qual è lo scopo dell'utilizzo di HitPaw?",
  surveyThemeQuestion: "Scegli la modalità che preferisci",
  surveyAnswerOther: "Altri",
  surveyAnswer1: "Video di vita",
  surveyAnswer2: "Video commerciale",
  surveyAnswer3: "Video aziendale",
  surveyAnswer4: "Video di marketing",
  surveyAnswer5: "Video sui social media",
  surveyAnswer6: "Presentazione video",
  surveyAnswer7: "Strumento video",
  surveyAnswer8: "Video di viaggio",
  surveyAnswer9: "Video di matrimonio",
  surveyAnswer10: "Video di compleanno",
  surveyAnswer11: "Video di bambino",
  surveyAnswer12: "Video di animale",
  surveyAnswer13: "Video di cibo",
  surveyAnswer14: "Video di moda",
  surveyAnswer15: "Video di vacanza",
  surveyAnswer16: "Video Sportivo",
  surveyAnswer17: "Video di fotografia",
  surveyAnswer18: "Video musicale",
  surveyAnswerLightMode: "Modalità di colore chiaro",
  surveyAnswerDarkMode: "Modalità di colore scuro",
  surveyNextBtn: "Prossimo",
  surveyBackBtn: "Indietro",
  surveyDoneBtn: "Finito",
  surveyStartBtn: "Iniziare",
  logoutWarnTips: "Sei sicuro di uscire?",
  ContinuewithGoogle: 'Continua con Google',
  Securityverification: 'Verifica della sicurezza',
  youraccount: 'Il tuo account',
  alreadyexiststoensurethesecuritypleaseverifyitfirst: 'esiste già, si prega di verificare.',
};

export default loginAndSignUp;
